import { t } from '@/lib/i18n';
import { Link, createFileRoute } from '@tanstack/react-router';
import { AsyncBoundary } from '@/components/async-boundary';
import { BrandLogo } from '@/components/brand-logo';
import { LegalDocumentLinks } from '@/features/legal/document/links';
import { LegalDocumentView } from '@/features/legal/document/view';
import { useLegalDocument } from '@/features/legal/legal-api';
import { legalDocumentKeyFromSegment } from '@/features/legal/legal-types';
import { useDocumentTitle } from '@/hooks/use-document-title';
import { appTitle } from '@/lib/env';

export const Route = createFileRoute('/legal/$documentKey')({
  component: LegalDocumentPage,
});

function LegalDocumentPage() {
  const { documentKey: segment } = Route.useParams();
  const documentKey = legalDocumentKeyFromSegment(segment);
  const document = useLegalDocument(documentKey);
  useDocumentTitle(document.data?.title ?? t('文书'));

  return (
    <div className="min-h-screen bg-[var(--ant-color-bg-layout)]">
      <main className="mx-auto flex max-w-3xl flex-col gap-6 px-6 py-10">
        <header className="flex flex-col gap-3">
          <Link
            to="/login"
            search={{ redirect: '/' }}
            className="inline-flex items-center gap-2"
          >
            <BrandLogo size={28} />
            <span className="font-medium">{appTitle}</span>
          </Link>
          <LegalDocumentLinks />
        </header>
        <AsyncBoundary result={document}>
          {(data) => (
            <>
              <h1 className="text-2xl font-semibold">{data.title}</h1>
              <LegalDocumentView document={data} />
            </>
          )}
        </AsyncBoundary>
      </main>
    </div>
  );
}
